import React from 'react';

interface OutlineTextAreaFieldProps {
  value: string | null;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  id?: string;
  className?: string;
  isMobile?: boolean;
  maxLength?: number;
}

const OutlineTextAreaField = ({ value, placeholder, onChange, id, className, isMobile, maxLength }: OutlineTextAreaFieldProps) => {
  return (
    <div className={`w-full ${isMobile && 'h-[152px]'}`}>
      <textarea id={id} className={`border rounded-lg p-4 ${className}`} placeholder={placeholder} value={value || ''} onChange={onChange} maxLength={maxLength} />
    </div>
  );
};

export default OutlineTextAreaField;
